import { Box, Typography } from '@mui/material'

import { PackageTypes } from 'constants/Packaging'
import { BookingAddress } from 'generated/graphql'
import { formatDimensions } from 'helpers'

import { SectionHeader } from './SectionHeader'

interface PackageSectionProps {
  pickupAddress?: BookingAddress | null
  dropoffAddress?: BookingAddress | null
  collectionAddress?: BookingAddress | null
}

const containerStyles = {
  mb: 4,
  borderBottom: '2px solid #F6F4F4',
  pb: 2,
}

const packageNameStyles = {
  fontSize: '16px',
  fontWeight: 600,
  color: '#333',
  mb: 0.5,
}

const dimensionsStyles = {
  fontSize: '14px',
  color: '#666',
}

export const PackageSection = ({ pickupAddress, dropoffAddress, collectionAddress }: PackageSectionProps) => {
  const colPackageIds = new Set(
    (collectionAddress?.addressPackages ?? []).map((ap) => String(ap.package?.id)),
  )
  const hasColFilter = colPackageIds.size > 0

  const rawAllocations = (dropoffAddress?.allocations ?? []).map((a) => ({ id: a.id, package: a.package }))
  const filteredAllocations = hasColFilter
    ? rawAllocations.filter((a) => colPackageIds.has(String(a.package?.id)))
    : rawAllocations

  const deliveryAddressPackages = dropoffAddress?.addressPackages ?? []
  const pickupAddressPackages = pickupAddress?.addressPackages ?? []

  const packages = filteredAllocations.length > 0
    ? filteredAllocations
    : deliveryAddressPackages.length > 0
      ? deliveryAddressPackages
      : pickupAddressPackages

  return (
    <Box sx={containerStyles}>
      <SectionHeader title='PACKAGE' />

      {packages.length === 0 ? (
        <Box sx={{ mb: 0 }}>
          <Typography variant='body1' sx={packageNameStyles}>
            {PackageTypes.PACKAGES}
          </Typography>
          <Typography variant='body2' sx={dimensionsStyles}>
            {formatDimensions(undefined)}
          </Typography>
        </Box>
      ) : (
        packages.map((addressPackage) => {
          const pkg = addressPackage.package
          const dimensions = formatDimensions(pkg)
          const packageName = (pkg?.type && PackageTypes[pkg.type]) || PackageTypes.PACKAGES

          return (
            <Box key={addressPackage.id} sx={{ mb: packages.length > 1 ? 2 : 0 }}>
              <Typography variant='body1' sx={packageNameStyles}>
                {packageName}
              </Typography>
              <Typography variant='body2' sx={dimensionsStyles}>
                {dimensions}
              </Typography>
            </Box>
          )
        })
      )}
    </Box>
  )
}
